import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../Include/Sidebar';
import Header from '../Include/Header';
import Breadcrumb from '../../../Components/Breadcrumb/Breadcrumb';
import moment from 'moment';
import Footer from '../Include/Footer';
import { Pagination, Search } from '../Table';
import DropDown from '../../../Components/DropDown';
import { getAdPrItems } from '../../../Store/Admin/VerifyPurRquest/viewAdPrItems';
import { getStatusLabel } from '../../Store/Prosafe/components/ProStatus/StatusFile';

const ReadOnlyInput = ({ label, value }) => (
  <div className="col-12 col-md-4 col-xl-4">
    <div className="input-block local-forms custom-select-wpr">
      <label>{label}</label>
      <input className="form-control" value={value || "-"} readOnly />
    </div>
  </div>
);

const ReadOnlyTextArea = ({ label, value }) => (
  <div className="col-12">
    <div className="input-block local-forms custom-select-wpr">
      <label>{label}</label>
      <textarea className="form-control" value={value || "-"} readOnly />
    </div>
  </div>
);

const ViewPurRequest = () => {

  const dispatch = useDispatch();
  const { state: data } = useLocation();
  const navigate = useNavigate();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [limit, setlimit] = useState(10);

  useEffect(() => {
    if (data?._id) {
      const formData = {
        id: data?._id
      }
      dispatch(getAdPrItems({ formData: formData }));
    }
  }, [data]);

  const itemData = useSelector((state) => state?.getAdPrItems?.user?.data);

  const breadcrumbItems = [
    { label: "Dashboard", link: "/main-store/user/dashboard" },
    { label: "Purchase Request", link: "/admin/verify-purchase-request" },
    { label: "View Purchase Request", active: true },
  ];

  const commentsData = useMemo(() => {
    let computedComments = itemData?.items_details;
    if (search) {
      computedComments = computedComments.filter(
        (fi) =>
          fi.party_name?.toLowerCase()?.includes(search?.toLowerCase()) ||
          fi.item_name?.toLowerCase()?.includes(search?.toLowerCase())
      );
    }
    setTotalItems(computedComments?.length);
    return computedComments?.slice(
      (currentPage - 1) * limit,
      (currentPage - 1) * limit + limit
    );
  }, [currentPage, search, limit, itemData]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const totals = useMemo(() => {
    return commentsData?.reduce(
      (acc, item) => {
        acc.required_qty += Number(item.required_qty) || 0;
        acc.amount += Number(item.amount) || 0;
        acc.total_amount += Number(item.total_amount) || 0;
        acc.gst_amount += Number(item.gst_amount) || 0;
        return acc;
      },
      {
        required_qty: 0,
        amount: 0,
        total_amount: 0,
        gst_amount: 0,
      }
    );
  }, [commentsData]);

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <Breadcrumb items={breadcrumbItems} />

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="col-12 d-flex justify-content-between">
                      <div className="form-heading">
                        <h4>View Purchase Request Details</h4>
                      </div>
                      <div>
                        Status:
                        <span className="ms-2">{getStatusLabel(data?.status) || "Unknown"}</span>
                      </div>
                    </div>

                    <div className='row'>
                      {/* <ReadOnlyInput label="Project No" value={data?.manual_pro_no || "-"} /> */}
                      <ReadOnlyInput label="Project" value={data?.project_details?.name || "-"} />
                      <ReadOnlyInput label="Prepared By" value={data?.prepare_by?.name || "-"} />
                      <ReadOnlyInput label="Approved By" value={data?.approve_by?.name ? `${data?.approve_by?.name} ${data?.approve_by?.approved_type === "STORE_USER" ? "(Main Store)" : data?.approve_by?.approved_type === "ADMIN" ? "(Admin)" : ""}` : "-"} />
                      <ReadOnlyInput label="Drawing No." value={data?.drawing_no?.join(" ,") || "-"} />
                      <ReadOnlyInput label="PR No." value={data?.voucher_no || "-"} />
                      <ReadOnlyInput label="PR Date" value={moment(data?.trans_date).format("YYYY-MM-DD")} />
                      <ReadOnlyInput label="Quotation" value={data?.quotation_details?.voucher_no || "-"} />
                      <ReadOnlyInput label="Store Quotation" value={data?.store_quotation_details?.voucher_no || "-"} />
                      <ReadOnlyInput label="Department" value={data?.department_name || "-"} />
                      <ReadOnlyInput label="Payment Method" value={data?.payment_method_name || "-"} />
                      <ReadOnlyInput label="Payment Remarks" value={data?.payment_remarks || "-"} />
                      <ReadOnlyInput label="Expected Delivery Date" value={data?.exp_delivery_date ? moment(data?.exp_delivery_date).format("YYYY-MM-DD") : "-"} />
                      {data?.verify_by?.reject_reason &&
                        <ReadOnlyInput label="Rejected Reason" value={data?.verify_by.reject_reason || "-"} />
                      }
                      {data?.rej_reason &&
                        <ReadOnlyInput label="Admin Rejected Reason" value={data?.rej_reason || "-"} />
                      }
                      <ReadOnlyTextArea label="Remarks" value={data?.remarks || "-"} />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="page-table-header mb-2 p-0">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="doctor-table-blk">
                          <h3>Items List</h3>
                          <div className="doctor-search-blk">
                            <div className="top-nav-search table-search-blk">
                              <form>
                                <Search
                                  onSearch={(value) => {
                                    setSearch(value);
                                    setCurrentPage(1);
                                  }} />
                                {/* eslint-disable jsx-a11y/anchor-is-valid */}
                                <a className="btn"><img src="/assets/img/icons/search-normal.svg"
                                  alt="search" /></a>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                        <DropDown limit={limit} onLimitChange={(val) => setlimit(val)} />
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table border-0 custom-table comman-table mb-0">
                      <thead>
                        <tr>
                          <th>Sr.</th>
                          {/* <th>Item No</th> */}
                          <th>Item Name</th>
                          <th>Party Name</th>
                          <th>Required Qty</th>
                          {/* <th>Item Length</th>
                          <th>Item Width</th> */}
                          {/* <th>Item Weight</th> */}
                          {/* <th>Item Radius</th>
                          <th>Item Thickness</th>
                          <th>Assembly Weight</th>
                          <th>Surface Area</th> */}
                          <th>Rate</th>
                          <th>Amount</th>
                          <th>GST (%)</th>
                          <th>GST Amount</th>
                          <th>Total Amount</th>
                          <th>Remarks</th>
                          <th>Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {commentsData?.map((item, index) => (
                          <tr key={item._id || index}>
                            <td>{index + 1}</td>
                            {/* <td>{item.item_no || "-"}</td> */}
                            <td>{item.item_name || "-"}</td>
                            <td>{item.party_name || "-"}</td>
                            <td>{item.required_qty || "-"}</td>
                            {/* <td>{item.item_length || "-"}</td>
                            <td>{item.item_width || "-"}</td> */}
                            {/* <td>{item.item_weight || "-"}</td> */}
                            {/* <td>{item.item_radius || "-"}</td>
                            <td>{item.item_thickness || "-"}</td>
                            <td>{item.assembly_weight || "-"}</td>
                            <td>{item.assembly_surface_area || "-"}</td> */}
                            <td>{item.rate || "-"}</td>
                            <td>{item.amount || "-"}</td>
                            <td>{item.gst || "-"}</td>
                            <td>{item.gst_amount || "-"}</td>
                            <td>{item.total_amount || "-"}</td>
                            <td>{item.remarks || "-"}</td>
                            <td>{item.isAuto ? "Auto" : "Manual"}</td>
                          </tr>
                        ))}
                        {commentsData?.length > 0 && (
                          <tr style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
                            <td colSpan="3" className="text-left font-bold" style={{ padding: "0 100px", fontWeight: "600" }}>Total</td>
                            <td style={{ fontWeight: "600" }}>{totals.required_qty}</td>
                            <td></td>
                            <td style={{ fontWeight: "600" }}>{totals.amount.toFixed(2)}</td>
                            <td></td>
                            <td style={{ fontWeight: "600" }}>{totals.gst_amount.toFixed(2)}</td>
                            <td style={{ fontWeight: "600" }}>{totals.total_amount.toFixed(2)}</td>
                            <td colSpan="2"></td>
                          </tr>
                        )}
                        {commentsData?.length === 0 ? (
                          <tr>
                            <td colSpan="999">
                              <div className="no-table-data">
                                No Data Found!
                              </div>
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </div>
                  <div className="row align-center mt-3 mb-2">
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                      <div className="dataTables_info" id="DataTables_Table_0_info" role="status"
                        aria-live="polite">Showing {Math.min(limit, totalItems)} from {totalItems} data</div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                      <div className="dataTables_paginate paging_simple_numbers"
                        id="DataTables_Table_0_paginate">
                        <Pagination
                          total={totalItems}
                          itemsPerPage={limit}
                          currentPage={currentPage}
                          onPageChange={(page) => setCurrentPage(page)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="col-12 text-end">
                    <div className="doctor-submit text-end">
                      <button type="button"
                        className="btn btn-primary submit-form me-2"
                        onClick={() => navigate("/admin/verify-purchase-request")}
                      >
                        Back
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <Footer />
      </div>
    </div>
  )
}

export default ViewPurRequest